import _defineProperty from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _set from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/set.js";
import _get from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/inherits.js";
var _excluded = ["repeat"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import ChangeDetails from '../core/change-details.js';
import IMask from '../core/holder.js';
import createMask, { normalizeOpts } from './factory.js';
import MaskedPattern from './pattern.js';
import '../core/utils.js';
import './base.js';
import '../core/continuous-tail-details.js';
import './pattern/chunk-tail-details.js';
import './pattern/cursor.js';
import './pattern/fixed-definition.js';
import './pattern/input-definition.js';
import './regexp.js';

/** Pattern mask */
var RepeatBlock = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(RepeatBlock, _MaskedPattern);
  function RepeatBlock(opts) {
    _classCallCheck(this, RepeatBlock);
    return _callSuper(this, RepeatBlock, [opts]);
  }
  _createClass(RepeatBlock, [{
    key: "repeatFrom",
    get: function get() {
      var _ref;
      return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref : 0;
    }
  }, {
    key: "repeatTo",
    get: function get() {
      var _ref2;
      return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(opts) {
      _get(_getPrototypeOf(RepeatBlock.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var _ref3, _ref4, _this$_blocks;
      var _normalizeOpts = normalizeOpts(opts),
        repeat = _normalizeOpts.repeat,
        blockOpts = _objectWithoutProperties(_normalizeOpts, _excluded); // TODO type
      this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
      var block = createMask(this._blockOpts);
      this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity; // TODO type

      _get(_getPrototypeOf(RepeatBlock.prototype), "_update", this).call(this, {
        mask: 'm'.repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
        blocks: {
          m: block
        },
        eager: block.eager,
        overwrite: block.overwrite,
        skipInvalid: block.skipInvalid,
        lazy: block.lazy,
        placeholderChar: block.placeholderChar,
        displayChar: block.displayChar
      });
    }
  }, {
    key: "_allocateBlock",
    value: function _allocateBlock(bi) {
      if (bi < this._blocks.length) return this._blocks[bi];
      if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
        this._blocks.push(createMask(this._blockOpts));
        this.mask += 'm';
        return this._blocks[this._blocks.length - 1];
      }
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      var details = new ChangeDetails();
      for (var bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated;
      // try to get a block or
      // try to allocate a new block if not allocated already
      block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi); ++bi) {
        var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
        var blockDetails = block._appendChar(ch, _objectSpread(_objectSpread({}, flags), {}, {
          _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
        }));
        if (blockDetails.skip && allocated) {
          // remove the last allocated block and break
          this._blocks.pop();
          this.mask = this.mask.slice(1);
          break;
        }
        details.aggregate(blockDetails);
        if (blockDetails.consumed) break; // go next char
      }
      return details;
    }
  }, {
    key: "_trimEmptyTail",
    value: function _trimEmptyTail(fromPos, toPos) {
      var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
      if (fromPos === void 0) {
        fromPos = 0;
      }
      var firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
      var lastBlockIndex;
      if (toPos != null) lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
      if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
      var removeCount = 0;
      for (var blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount) {
        if (this._blocks[blockIndex].unmaskedValue) break;
      }
      if (removeCount) {
        this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
        this.mask = this.mask.slice(removeCount);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(RepeatBlock.prototype), "reset", this).call(this);
      this._trimEmptyTail();
    }
  }, {
    key: "remove",
    value: function remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      var removeDetails = _get(_getPrototypeOf(RepeatBlock.prototype), "remove", this).call(this, fromPos, toPos);
      this._trimEmptyTail(fromPos, toPos);
      return removeDetails;
    }
  }, {
    key: "totalInputPositions",
    value: function totalInputPositions(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos == null && this.repeatTo === Infinity) return Infinity;
      return _get(_getPrototypeOf(RepeatBlock.prototype), "totalInputPositions", this).call(this, fromPos, toPos);
    }
  }, {
    key: "state",
    get: function get() {
      return _get(_getPrototypeOf(RepeatBlock.prototype), "state", this);
    },
    set: function set(state) {
      this._blocks.length = state._blocks.length;
      this.mask = this.mask.slice(0, this._blocks.length);
      _set(_getPrototypeOf(RepeatBlock.prototype), "state", state, this, true);
    }
  }]);
  return RepeatBlock;
}(MaskedPattern);
IMask.RepeatBlock = RepeatBlock;
export { RepeatBlock as default };